"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contractProps = exports.addressData = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var addressData = exports.addressData = {
  premiseId: _propTypes.default.string.isRequired,
  street: _propTypes.default.string.isRequired,
  houseNumber: _propTypes.default.string,
  houseNumberSupplement: _propTypes.default.string,
  postalCode: _propTypes.default.string.isRequired,
  city: _propTypes.default.string.isRequired,
  pointOfConsumptionId: _propTypes.default.string.isRequired
};
var contractProps = exports.contractProps = {
  contractAccountId: _propTypes.default.string.isRequired,
  assOrderId: _propTypes.default.string,
  active: _propTypes.default.bool.isRequired,
  division: _propTypes.default.string.isRequired,
  customerGroup: _propTypes.default.string.isRequired,
  pointOfConsumptions: _propTypes.default.arrayOf(_propTypes.default.shape(addressData)),
  meterSerialNumbers: _propTypes.default.arrayOf(_propTypes.default.string),
  permissions: _propTypes.default.arrayOf(_propTypes.default.string),
  businessPartner: _propTypes.default.shape({
    businessPartnerId: _propTypes.default.string.isRequired,
    type: _propTypes.default.string.isRequired,
    name1: _propTypes.default.string,
    name2: _propTypes.default.string,
    name3: _propTypes.default.string,
    name4: _propTypes.default.string,
    firstName: _propTypes.default.string,
    lastName: _propTypes.default.string,
    salutation: _propTypes.default.string,
    academicTitle: _propTypes.default.string
  }),
  _links: _propTypes.default.shape({
    self: _propTypes.default.shape({
      href: _propTypes.default.string
    }),
    businesspartners: _propTypes.default.shape({
      href: _propTypes.default.string
    }),
    mydata: _propTypes.default.shape({
      href: _propTypes.default.string
    }),
    contractconsumptions: _propTypes.default.shape({
      href: _propTypes.default.string
    })
  })
};